<!-- h -->
<template>
  <div>
    <el-button type="primary" @click="test" v-if="false">test</el-button>
    <el-checkbox v-model="stageListCheckAll" :indeterminate="isIndeterminate" @change="handleCheckAllChange" class="chkAll">全选</el-checkbox>
    <div style="margin: 15px 0;"></div>
    <el-checkbox-group v-model="checkedStageList" @change="handleCheckedItemChange">
      <el-checkbox v-for="item in machiningStageList" :label="item.Name" :key="item.MachiningStageId">{{item.Name}}</el-checkbox>
    </el-checkbox-group>
  </div>
</template>
<script>
export default {
  data() {
    return {
      data: {
      },
      sourceData: [],

      machiningStageList: [], // <!-- h -->
      checkedStageList: [], // <!-- h -->
      stageListCheckAll: false, // <!-- h -->
      isIndeterminate: false, // <!-- h -->
    }
  },
  methods: {
    // <!-- h -->
    test() {
      
    },
    setData(allList, selList) {
      this.machiningStageList = allList;
      while (this.checkedStageList.length > 0) {
        this.checkedStageList.pop();
      };
      selList.map(item => {
        this.checkedStageList.push(item.Name);
      });            

      this.stageListCheckAll = selList.length === this.machiningStageList.length;
      this.$set(this, "isIndeterminate", selList.length > 0 && selList.length < this.machiningStageList.length);
    },
    handleCheckAllChange(val) {
      var chkList = val === true ? [...this.machiningStageList] : [];
          
      while (this.checkedStageList.length > 0) {
        this.checkedStageList.pop();
      }

      if (chkList.length > 0) {
        chkList.map(item => {
          this.checkedStageList.push(item.Name);
        })
      }
      else {
        this.checkedStageList = [];
      }

      this.isIndeterminate = false;
    },
    handleCheckedItemChange(value) {
      let checkedCount = value.length;
      this.stageListCheckAll = checkedCount === this.machiningStageList.length;
      //this.isIndeterminate = checkedCount > 0 && checkedCount < this.machiningStageList.length;
      this.$set(this, "isIndeterminate", checkedCount > 0 && checkedCount < this.machiningStageList.length);
    },

    getChecked() {
      return this.checkedStageList;
    },
    // <!-- h -->

  }
}
</script>
<style scoped>
._checkbox {
  margin-right: 10px;
}
.chkAll {
  color: #bbb;
}
</style>